import { createFileRoute, redirect } from "@tanstack/react-router";
import { client, UnavailableDataError } from "@/data";
import { q } from "@/data/queries";
import { projectPath } from "@/lib/nav";

/** The app has no landing page: it opens on the first project's overview. */
export const Route = createFileRoute("/")({
  loader: async ({ context }) => {
    const projects = await context.queryClient.ensureQueryData(q.projects());
    const [project] = projects;
    if (!project)
      throw new UnavailableDataError(
        "workspace.projects",
        "No projects yet. Open account setup to create your first project.",
      );
    // biome-ignore lint/suspicious/noExplicitAny: see components/common/app-link.tsx.
    throw redirect({
      to: projectPath(client.kind === "http" ? project.id : project.slug) as any,
      replace: true,
    });
  },
});
